import { sortArray } from "components/results/analysis-results/sortUtil";
import text from "components/results/analysis-results/text";
import { AnalysisItem, LegendItem } from "helpers/models";
import { Content } from "pdfmake/interfaces";
import gap from "report/common/gap";
import page from "report/common/page";
import getTitle from "report/common/title";
import getTpye from "report/common/type";
import getDetail from "./analysis/detail";
import getOverview from "./analysis/overview";

const get = (
  t: any,
  analysisItems: AnalysisItem[],
  legendItems: LegendItem[]
): Content[] => {
  const notDataArray = analysisItems.filter(
    (e) =>
      !e.valueLabel ||
      e.valueLabel === "No Data" ||
      ((e.layerId === "DR_Subsidence_France_SwissRe" ||
        e.layerId === "WF_DistToBush_AUS_SwissRe") &&
        (e.valueLabel === "Outside" ||
          e.valueLabel === "Negligible" ||
          e.valueLabel === "No Observation"))
  );
  const notDataIds = notDataArray.map((e) => e.layerId);
  const analysisItemArray = analysisItems.filter(
    (e) => !notDataIds.includes(e.layerId)
  );
  const sortItemArray = analysisItemArray.sort((a, b) => {
    return sortArray.indexOf(a.layerId) - sortArray.indexOf(b.layerId);
  });
  return [
    getTpye(t("report.hazard")),
    gap(30),
    getTitle(t("report.Analysis Overview")),
    getOverview(t, sortItemArray, legendItems),
    gap(20),
    text(t, notDataIds),
    page(),
    getTitle(t("report.analysis")),
    getDetail(t, sortItemArray, legendItems)
  ];
};

export default get;
